import { createInjectionKey as o } from "./ghl-ui.es920.js";
const n = o("n-popover-body");
export {
  n as popoverBodyInjectionKey
};
